


























































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
import { routingControlModule } from '../../store/modules/RoutingControl';
import { ScreenName } from '../../CommonUtils/fixed/ScreenName';
import { applicationFormModule } from '../store/modules/ApplicationForm';
import router from '../../router';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';

@Component
export default class UketsukeMenu extends Vue {
  created() {
    applicationFormModule.moduleReset();
    applicationFormModule.resetFormData();
  }
  onClickConst() {
    routingControlModule.registPrevious(this.$route.name);
    router.push({name: UketsukeScreenName.UKETSUKE_ORDER_MAIN});
    applicationFormModule.setTypeConst();
  }
  onClickConsul() {
    routingControlModule.registPrevious(this.$route.name);
    router.push({name: UketsukeScreenName.UKETSUKE_ORDER_MAIN});
    applicationFormModule.setTypeConsul();
  }
  onClickGoods() {
    routingControlModule.registPrevious(this.$route.name);
    router.push({name: UketsukeScreenName.UKETSUKE_ORDER_MAIN});
    applicationFormModule.setTypeGoods();
  }
}
